import colors from './colors'

export default {
  grey: `1px solid ${colors.grey7}`,
  grey4: `1px solid ${colors.grey4}`,
  grey5: `1px solid ${colors.grey5}`,
  grey6: `1px solid ${colors.grey6}`,
  darkerGrey6: `1px solid ${colors.darkerGrey6}`,
  grey13: `1px solid ${colors.grey13}`,
  green: `3px solid ${colors.green}`,
  green3: `1px solid ${colors.green3}`,
  outline: `1px solid ${colors.green}`,
  transparent: `1px solid transparent`,
  red: `1px solid ${colors.red}`,
  blue: `3px solid ${colors.blue}`,
}
